// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sc-nav{margin-left:354px}.a-slider-nav__btn:disabled{color:#949494;cursor:default;opacity:1}@media screen and (max-width:959px){.sc-nav{margin-left:0}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
